// src/cookie.js
// Lightweight cookie read/write for persisting user preferences.
// Cookies survive across browser sessions and are sent with requests.

const DEFAULT_MAX_AGE = 365 * 24 * 60 * 60; // 1 year in seconds

export function setCookie(name, value, maxAge = DEFAULT_MAX_AGE) {
  try {
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
  } catch { /* cookie access may be blocked */ }
}

export function getCookie(name) {
  try {
    const prefix = `${encodeURIComponent(name)}=`;
    for (const c of document.cookie.split('; ')) {
      if (c.startsWith(prefix)) return decodeURIComponent(c.slice(prefix.length));
    }
  } catch { /* cookie access may be blocked */ }
  return null;
}

export function removeCookie(name) {
  try {
    document.cookie = `${encodeURIComponent(name)}=; path=/; max-age=0; SameSite=Lax`;
  } catch { /* cookie access may be blocked */ }
}
